// extracted by mini-css-extract-plugin
export default {"container":"eldHu5","title":"vQF3u3","textButton":"lID0Hy"};